import { GAUserContext } from '../../interfaces/googleAnalytics'
import { fetchEnv } from '../fetchEnv'

export const deviceInfo = {
  language: navigator.language,
  platform: fetchEnv('GA_PLATFORM') as GAUserContext['platform'],
  version: fetchEnv('APP_VERSION'),
}
